import {setLocalItem} from "../storage/LocalStorage";
import {createOptions} from "./OptionsMapper";
import {
  genderOptions,
  interfaceTexts,
  languagesOptions,
  nationalitiesOptions,
  privacyOptions,
  blockOptions
} from "../storage/LocalStorageIds";

export const langSchemeMapper = (langScheme) => {
  setLocalItem(interfaceTexts, langScheme.texts)
  const nationalities = createOptions(langScheme.nationalities)
  setLocalItem(nationalitiesOptions, nationalities)
  const languages = createOptions(langScheme.languages)
  setLocalItem(languagesOptions, languages)
  const genders = createOptions(langScheme.gender)
  setLocalItem(genderOptions, genders)
  const privacyOpt = createOptions(langScheme.privacypubs)
  setLocalItem(privacyOptions, privacyOpt)
  const blockReasons = createOptions(langScheme.Reasons)
  setLocalItem(blockOptions, blockReasons)
  return true;
}